import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Voucher } from "../types/Voucher";
import { GET_VOUCHERS_KEY } from "./useGetVouchers";
import { API, fetcher } from "@/shared/core-configs";

export const toggleVoucher = async ({
  id,
  enabled,
}: {
  id: string;
  enabled: boolean;
}): Promise<Voucher> => {
  const res = await fetcher.put(`${API.GESLUB_SERVICE}/voucher/${id}/enabled`, {
    enabled,
  });
  return res.data;
};

export const useToggleVoucher = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: toggleVoucher,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GET_VOUCHERS_KEY],
      });
    },
  });

  return {
    toggleVoucher: mutateAsync,
    isPending,
  };
};
